<template>

    <div class="modal fade" id="searchProjectModal" tabindex="-1" role="dialog" v-if="dataLoaded">
        <div class="modal-dialog modal-lg modal-xl" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true"><i class="mdi mdi-close"></i></span></button>
                    <h4 class="modal-title" v-text="lang.get('projects.fg.header')"></h4>
                </div>
                <div class="modal-body text-center" v-if="getGrids['projects']">
                    <server-table
                        :data-columns="JSON.stringify(getGrids.projects.columns)"
                        :data-url="getGrids.projects.uri"
                        :preference-url="getGrids.projects.preferenceurl"
                        :doubleClickCb="dbclckCb"
                    ></server-table>
                </div>
            </div>
        </div>
    </div>

</template>

<script>

    import { mapGetters, mapActions } from 'vuex';
    import Hub from '../../../Hub';
    import Lang from '../../../Lang';
    import ServerTable from '../../../Libraries/ServerTable/DefaultServerTable';

    export default {

        components: {
            ServerTable,
        },

        computed: {
            ...mapGetters([
                'dataLoaded',
                'getGrids',
            ])
        },

        data() {
            return {
                lang:Lang,
            }
        },

        destroyed() {
            Hub.$off('close-project-selector', this.closeSelector);
            Hub.$off('open-project-selector', this.openSelector);
        },

        methods: {

            closeSelector() {
                $('#searchProjectModal').modal('hide');
            },

            dbclckCb(e) {
                this.closeSelector();
                this.onSelected(e);
            },

            openSelector() {
                $('#searchProjectModal').modal('show').on("shown.bs.modal");
            },

        },

        mounted() {
            this.$nextTick(function () {
                Hub.$on('close-project-selector', this.closeSelector);
                Hub.$on('open-project-selector', this.openSelector);
            }.bind(this));
        },

        name: "ProjectSelector",

        props: {
            onSelected: Function
        },
    }

</script>
